import classNames from 'classnames';
import type { FC, PropsWithChildren, ReactNode } from 'react';
import { Text } from '../text/text';
import styles from './field-footer.module.scss';

export type FieldFooterProps = PropsWithChildren & {
  className?: string;
  'data-testid'?: string;
  disabled?: boolean;
  error?: boolean;
  icon?: ReactNode;
  id?: string;
};

export const FieldFooter: FC<FieldFooterProps> = ({
  children,
  className,
  'data-testid': testId,
  disabled,
  error,
  icon,
  id,
}) => (
  <div
    aria-live={error ? 'assertive' : undefined}
    className={classNames(styles.footer, disabled && styles.disabled, className)}
    data-testid={testId}
    id={id}
    role={error ? 'alert' : 'note'}
  >
    {icon && (
      <span aria-hidden className={styles.icon}>
        {icon}
      </span>
    )}
    <Text size="xs">{children}</Text>
  </div>
);
